import RadioButtonField from "../../../Utils/RadioButtonField"
import { careerProfileLabels } from "../../../Types/careerProfileLabels"
import PastJob from "./PastJob"
import styles from "../../../../../styles/Participant-Employment.module.css"
import { Button } from "primereact/button"
import { deleteConfirmationModal } from "../../../Utils/formikAux"
const WorkExperience = ({
  formik,
  setEditPastJob,
  setPastJobFormVisible,
  setDeletePastJob,
  pastJobFormVisible,
  deletePastJob,
  editPastJob,
}) => {
  const jobsTable = () => {
    return (
      <table
        className={styles.table}
        style={{
          marginBottom: "1rem",
          paddingTop: "17px",
          paddingLeft: "16px",
          paddingBottom: "23px",
          paddingRight: "15px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Employer
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Job title
            </th>
          </tr>
        </thead>
        <tbody>
          {formik.values.past_jobs.map((e) => {
            return (
              <tr key={e.id}>
                <td>{e.employer}</td>
                <td>{e.jobTitle}</td>
                <td
                  style={{
                    textAlign: "center",
                    width: "80px",
                    paddingRight: "1rem",
                  }}
                >
                  {
                    <div className={styles.table_actions}>
                      <Button
                        icon="pi pi-pencil"
                        className={styles.rounded_btn}
                        type="button"
                        onClick={() => {
                          setEditPastJob(e)
                          setPastJobFormVisible(true)
                        }}
                      />
                      <Button
                        icon="pi pi-trash"
                        className={styles.rounded_btn}
                        type="button"
                        onClick={() => {
                          setDeletePastJob(e.id)
                        }}
                      />
                    </div>
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      //agregar aqui el boton para abrir el form
    )
  }
  const removePastJob = (id) => {
    formik.setFieldValue(
      "past_jobs",
      formik.values.past_jobs.filter((p) => p.id !== id)
    )
  }
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.workExperience.workExperience_1.label}
          value={formik.values.hadJob_1}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.workExperience.workExperience_1.value}
          callback={(value) => {
            if (value !== "Yes") {
              formik.setFieldValue("past_jobs", [])
            }
          }}
        />
      </div>
      <PastJob
        setVisible={setPastJobFormVisible}
        visible={pastJobFormVisible}
        edit={editPastJob}
        setEdit={setEditPastJob}
        setValue={formik.setFieldValue}
        jobs={formik.values.past_jobs}
      />
      {formik.values.hadJob_1 === "Yes" && (
        <div className={styles.education_wrapper}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <label
              style={{
                paddingTop: "5px",
                fontSize: "16px",
                fontWeight: "600",
                color: "#383838",
                width: "60%",
              }}
            >
              Past work experience
            </label>
            <Button
              className={styles.button}
              style={{ height: "38px" }}
              label="Add new job"
              onClick={() => {
                setPastJobFormVisible(true)
              }}
              type="button"
            />
          </div>
          <div style={{ width: "70%", marginBottom: "10px" }}>
            <label
              style={{
                paddingTop: "5px",
                fontSize: "16px",
                fontWeight: "400",
                color: "#383838",
              }}
            >
              Please input all past work experience starting with the most
              recent employment
            </label>
          </div>

          {formik.values.past_jobs?.length > 0 && jobsTable()}
        </div>
      )}

      {deleteConfirmationModal(
        deletePastJob,
        setDeletePastJob,
        removePastJob,
        "past job"
      )}
    </>
  )
}
export default WorkExperience
